import React from "react"
import styled from "@emotion/styled"
/** @jsx jsx */
import { css,  jsx } from '@emotion/react'
import FeaturedImage from "./featured-image"
import { roundButtonStyles } from "../../components/commons/round-button-styles"
import { Link } from "gatsby"

function FeaturedItem({ acf }) {
  /*
   * Creates highlighted item on home
   */

  //ACF
  const {
    // cta,
    lead,
    item,
    shapes
  } = acf

  const {
    // id,
    slug,
    title,
    featuredImage,
  } = item

  return (
    <HeroArticle>
      <HeroFigure>
        <FeaturedImage featuredImage={featuredImage} />
      </HeroFigure>
      <HeroHeader>
        <HeroShape>
          <img src={require(`./../../assets/img/shapes/shape_${shapes || '0'}.svg`).default} />
        {/* <svg xmlns="http://www.w3.org/2000/svg" width="856.019" height="1014.274" viewBox="0 0 856.019 1014.274">
          <path id="Path_293" data-name="Path 293" d="M640.632,445.134a58.564,58.564,0,0,1-6.913-8.593c-.262-.028-.521-.09-.787-.108-8.247-8.267-15.281-17.731-23.87-25.785-10.5-9.843-21.279-19.393-31.92-29.084-21.08-19.2-42.363-38.207-62.988-57.908-9.438-9.015-17.984-18.886-27.325-28-9.726-9.49-20.756-17.373-31.865-25.135-18.625-13.015-41.678-23.5-54.042-43.375a114.179,114.179,0,0,0,5.517-12.293c2.648-7.332,3.234-15.169,5.3-22.663,4.125-14.97,12.92-28.376,18.843-42.674,5.8-14,14.439-26.313,20.871-39.981a97.708,97.708,0,0,0,6.875-20.481c1.7-7.433,5.006-14.147,4.889-21.89A13.283,13.283,0,0,0,454.75,54.49a13.95,13.95,0,0,0-.517-3.755C405.477,42.19,356.958,32.1,308.55,22.107c-27.851-5.753-55.916-7.429-88.185-11.494C200.946,8.163,181.337,5.449,162.515.157c-1.875.137-3.75.252-5.626.3a15.081,15.081,0,0,0-5.026.967c-4.745-2.388-10.552-2.067-15.2,3.238C112.894,31.8,88.2,58.143,64.511,85.316c-22.891,26.255-37.7,58.38-60.737,84.458-9.655,10.923,1,25.951,11.949,24.882,2.3,2.475,5.72,3.986,10.283,3.66,7.36-.525,14.429,2.413,21.71,3.411,8.021,1.1,16.166,1.293,24.149,2.644,15.671,2.657,30.777,5.9,46.767,6.02q23.1.173,46.225-.112c5.927-.065,15.761-1.246,22.711.874a69.7,69.7,0,0,0-1.88,7.429c-1.922,9.756-4.988,18.663-8.25,28.033-6.889,19.772-10.75,40.938-15.771,61.261-2.465,9.962-4.4,20.187-7.726,29.9-3.562,10.413-7.751,20.05-9.886,30.929-4.3,21.877-11.356,43.2-15.108,65.139a15.109,15.109,0,0,0,.4,7.01,15.4,15.4,0,0,0-.91,4.86c-.292,9.992,2.634,18.895,5.168,28.42,2.359,8.878,3.79,18,6.034,26.915,4.816,19.134,11.161,37.9,17.388,56.607,12.316,37.023,26.969,73.215,39.209,110.247,12.024,36.387,24.783,71.223,41.112,105.911a341.9,341.9,0,0,1,17.062,43.386c2.884,9.182,6.176,17.872,11.576,25.221.8,6.436,5.364,12.311,13.736,12.314h.62a11.11,11.11,0,0,0,7.263.015h.269a79.49,79.49,0,0,0,14.1,2.1c13.011,1.076,25.092,6.327,38.215,7.574,14.512,1.376,29.534.31,44.111.354,14.219.043,29.739-1.869,43.574,1.922,26.243,7.187,54.718,4.054,81.742,4.1,6.768.01,13.531.35,20.25-.611,6.388-.918,12.379-3.3,18.84-3.591,13.383-.615,27.006.039,40.457.183,7.206,3.013,17.122,1.012,20.535-8.5,5.779-16.091,4.582-32.643,4.2-49.409-.387-16.955,4.907-32.3,6.793-48.975,4.054-35.813,3.6-71.769,6.41-107.693.936-11.982,1.62-24.051,2.649-36.063a33.071,33.071,0,0,1-.8-17.687c.9-3.794,1.918-7.545,2.989-11.274-.012-.7-.048-1.412-.048-2.116a28.868,28.868,0,0,1,.934-7.191,35.051,35.051,0,0,1,.148-13.395C641.08,525.325,637.528,484.892,640.632,445.134Z" transform="translate(0 176.582) rotate(-16)" fill="#789a78"/>
        </svg> */}
        </HeroShape>
        <Title>{title}</Title>
        <Lead>{lead}</Lead>
        <Link to={`/${slug}`} css={css`&:hover {filter: none;}`}>
          <RoundedLink colors={{color: 'white', bkg: 'transparent', hoverColor: "#789a78"}}>
          Receita completa
          </RoundedLink>
        </Link>
      </HeroHeader>
    </HeroArticle>
  )
}

export default FeaturedItem

const HeroArticle = styled.article`
  display: flex;
  left: 50%;
  margin-top: -55px;
  padding-top: 55px;
  position: relative;
  transform: translateX(-50%);
  width: 100vw;
  z-index: 99;

  @media (min-width: 991px) {
    margin-top: 0;
    padding-top: 0;
    z-index: 0;
  }
`

const HeroFigure = styled.figure`
  flex: 0 0 100%;
  margin: 0;

  @media (min-width: 991px) {
    flex: 0 0 50%;
  }
`

const HeroHeader = styled.header`
  bottom: 0;
  left: 0;
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 991px) {
    flex: 0 0 50%;
    position: relative;
    
    padding-top: 70px;
    
    &::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #D7C0CF;
      z-index: -2;
    }
  }
`

const HeroShape = styled.div`
  display: none;

  @media (min-width: 991px) {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    height: 100%;
    transform: translate(-50%, -50%);
    width: 100%;
    z-index: -1;
    svg {
      width: 100%;
      height: 100%;
      fill: #789A78;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

const Title = styled.h1`
  color: #e1e1d4;
  font-size: 4.375rem;
  font-weight: 400;
  text-transform: uppercase;
  text-align: center;

  @media (min-width: 991px) {
    font-size: 6.25rem;
    width: 80%;
    max-width: 470px;
    margin: 0 auto;
  }
`

const Lead = styled.p`
  color: #e1e1d4;
  font-size: 1.125rem;
  font-weight: 500;
  text-align: center;

  @media (min-width: 991px) {
    margin: 10px 0 40px;
  }
`
const RoundedLink = styled.span`
  ${roundButtonStyles}
`